import React from 'react';

const Hero = () => {
  const goToCalendly = (e) => {
    e.preventDefault();
    window.location.href = 'https://calendly.com/sethmichaelking';
  };

  return (
    <div>
      <section className="bg-white">
        <div className="bg-white grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-1">
          {/* Centered Text */}
          <div className="place-self-center text-center">
            <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl text-black">
              Get Your{' '}
              <span className="bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent animate-bounce-short bg-clip-text">
                Brand Mentioned
              </span>
              <br /> In The Press
            </h1>
            <p className="max-w-2xl mb-6 font-light text-gray-900 lg:mb-8 md:text-lg lg:text-xl">
              AI-Powered PR to get your brand featured in top-tier publications.
            </p>
            <div className="flex justify-center">
              <button
                type="button"
                onClick={(e) => goToCalendly(e)}
                className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5"
              >
                Schedule A Call
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
